export default "__VITE_ASSET__38e93bbb__"